<template>
    <b-card title="">
        <h3 class="text-primary font-weight-bold mb-2">อัพเดทสถานะการจ่ายเงิน</h3>

        <b-row>
            <b-col md="6">
                <h5 class="h4 font-weight-bold"> AL Code</h5>
                <b-form-group class="font-weight-bold" label="" label-for="IdCode">
                    <b-form-input id="IdCode" v-model="formUser.IdCode" placeholder=" AL Code" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <b-form-group>
                    <h5 class="h4 font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
                    <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
                </b-form-group>
            </b-col>

            <b-col md="6">
                <b-form-group>
                    <h5 class="h4 font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
                    <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
                </b-form-group>
            </b-col>

            <b-col md="6" class="mt-2">
                <b-button variant="primary" @click.prevent="getDataTable"> ค้นหา </b-button>
            </b-col>

            <b-col md="12" class="mt-3">
                <h3 class="text-primary font-weight-bold mb-2">ตารางแสดงรายการจองคิวที่ศุนย์</h3>
            </b-col>

            <b-col md="6" sm="4" class="my-1">
                <b-form-group class="mb-0">
                    <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
                    <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
                        @change="handleItemsPerPageChange" />
                </b-form-group>
            </b-col>

            <b-col md="6" class="my-1">
                <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm"
                    label-for="filterInput" class="h5 mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">ยกเลิก</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-col cols="12">
            <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #head(select)>
                    <b-form-checkbox :indeterminate="isIndeterminate" :checked="allSelected"
                        @change="toggleSelectAll"></b-form-checkbox>
                </template>
                <template #cell(status)="data">
                    <span :class="{
                        'badge badge-success': data.item.status === 'confirmed',
                        'badge badge-primary': data.item.status === 'pending'
                    }">
                        {{ data.item.status }}
                    </span>
                </template>

                <!-- Checkbox per row -->
                <template #cell(select)="row">
                    <b-form-checkbox v-model="row.item._selected" @change="updateSelectAllState"></b-form-checkbox>
                </template>

                <template #cell(action)="props">
                    <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)" title="ปริ้น">
                        <feather-icon icon="PrinterIcon" />
                    </b-button>
                </template>
            </b-table>
        </b-col>

        <!-- Pagination -->
        <b-card v-show="true" class="p-0 mb-1" no-body>
            <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
                <div>
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
                </div>
                <div class="bd-highlight">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                        @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next"
                        last-text="Last" align="left" hide-goto-end-buttons />
                </div>
            </b-nav>
        </b-card>

        <b-row class="justify-content-center mt-3">
            <b-col cols="8" class="d-flex justify-content-center">
                <b-button variant="success" @click="Payment" :disabled="!hasSelected"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'">
                    ยืนยันการจ่ายเงินและอัพเดทสถานะ
                </b-button>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BNav,
    BCard,
    BCardText,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
    directives: { Ripple },
    components: {
        BTable, BAvatar, BBadge, BRow, BCard, BCardText, BCol,
        BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
        BInputGroupAppend, BButton, BNav, flatPickr,
    },
    data() {
        return {
            perPage: 100,
            pageOptions: [25, 50, 100],
            totalRows: 0,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            isBusy: false,
            items: [],
            filter: null,
            filterOn: [],
            fields: [
                { key: "select", label: "", sortable: false },
                { key: "no", label: "ลำดับที่" },
                { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
                { key: "prefix", label: "คำนำหน้า" },
                { key: "firstname", label: "ชื่อ" },
                { key: "lastname", label: "นามสกุล" },
                { key: "gender", label: "เพศ" },
                { key: "status", label: "สถานะ" },
                { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
            ],
            startDate: new Date(),
            endDate: new Date(),
            DateConfig: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d-m-Y",
            },
            formUser: { IdCode: "" },
        };
    },
    computed: {
        allSelected() {
            return this.items.length > 0 && this.items.every(item => item._selected);
        },
        isIndeterminate() {
            const total = this.items.length;
            const selected = this.items.filter(i => i._selected).length;
            return selected > 0 && selected < total;
        },
        hasSelected() {
            return this.items.some(item => item._selected);
        },
    },
    methods: {
        async getDatauserFromCompany(_userId) {
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));
                const params = { companyId: jwt.companyId, userId: _userId };
                const res = await axios.get(`${API}userFromCompany`, {
                    params,
                    headers: { Authorization: await store.dispatch("getAuthorization") },
                });
                return res.data.message.data;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            }
            return;
        },
        async getDataTable() {
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));
                const startStr = this.formatDate(new Date(this.startDate));
                const endStr = this.formatDate(new Date(this.endDate));

                const [dayExit, monthExit, yearExit] = startStr.split("-");
                const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

                let params = {
                    userId: jwt.userId,
                    includeCompany: 'true',
                    startDate: `${yearExit}${monthExit}${dayExit}`,
                    endDate: `${yearEntry}${monthEntry}${dayEntry}`,
                    emptyStationName: 'true',
                    _page: this.currentPage,
                    _limit: this.perPage,
                    _sort: "-1",
                };

                if (this.formUser.IdCode && this.formUser.IdCode.trim() !== "") {
                    params.IdCode = this.formUser.IdCode;
                }

                const res = await axios.get(`${API}pendingEntry`, {
                    params,
                    headers: { Authorization: await store.dispatch("getAuthorization") },
                });

                if (!res.data.message.data || !res.data.message.total) {
                    this.items = [];
                    this.totalRows = 0;
                    return;
                }

                const results = await Promise.all(
                    res.data.message.data.map(async (item, index) => {
                        const datausername = await this.getDatauserFromCompany(item.userId);
                        var sp = item.createdAt.split(' ');
                        var createdAtFormatted_img = sp[0].split('/');

                        return {
                            ...item,
                            no: index + 1,
                            createdAtFormatted: createdAtFormatted_img.join('/'),
                            _selected: false,
                            prefix: datausername ? datausername.prefix : '',
                            firstname: datausername ? datausername.firstname : '',
                            lastname: datausername ? datausername.lastname : '',
                            gender: datausername ? datausername.gender : '',
                        };
                    })
                );

                this.items = results;
                this.totalRows = res.data.message.total;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }
        },
        formatDate(dateObj) {
            if (typeof dateObj === 'string') dateObj = new Date(dateObj);
            if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
            const day = String(dateObj.getDate()).padStart(2, "0");
            const month = String(dateObj.getMonth() + 1).padStart(2, "0");
            const year = String(dateObj.getFullYear());
            return `${day}-${month}-${year}`;
        },
        handlePrint(item) {
            console.log("พิมพ์ข้อมูล:", item);
        },
        async Payment() {
            const selectedUsers = this.items.filter(item => item._selected);

            if (selectedUsers.length === 0) {
                this.$swal({
                    icon: "warning",
                    title: "กรุณาเลือกรายการ",
                    text: "กรุณาเลือกรายการอย่างน้อย 1 รายการก่อนทำการยืนยัน",
                    confirmButtonText: "ตกลง",
                    customClass: {
                        confirmButton: "btn btn-warning",
                    },
                });
                return;
            }

            // ✅ ใช้ swal ถามก่อน
            const result = await this.$swal({
                title: "คุณต้องการยืนยันการจ่ายเงิน?",
                text: "ระบบจะอัพเดทสถานะเป็นจ่ายเงินแล้ว",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger ml-2",
                },
                buttonsStyling: false,
            });

            if (!result.isConfirmed) {
                return; // ❌ ถ้าเลือกยกเลิก
            }

            try {
                const auth = await store.dispatch("getAuthorization");

                for (let user of selectedUsers) {
                    let payload = {
                        userId: user.userId,
                        status: "confirmed", // เปลี่ยนเป็นค่าที่คุณใช้จริง
                    };

                    console.log("ส่ง API:", payload);

                    await axios.post(`${API}updatePaymentStatus`, payload, {
                        headers: { Authorization: auth },
                    });
                }

                // ✅ แจ้งเตือนสำเร็จ
                this.$swal({
                    icon: "success",
                    title: "บันทึกข้อมูล!",
                    text: "บันทึกข้อมูลสำเร็จ",
                    showConfirmButton: false,
                    timer: 1500,
                });

                // refresh ตาราง
                await this.getDataTable();

            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                this.$swal({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด!",
                    text: "กรุณาลองใหม่อีกครั้ง",
                    confirmButtonText: "ตกลง",
                    customClass: { confirmButton: "btn btn-danger" },
                });
            }
        }
        ,
        async handlePageChange(page) {
            this.currentPage = page;
            this.items = [];
            await this.getDataTable();
        },
        async handleItemsPerPageChange() {
            this.items = [];
            this.currentPage = 1;
            await this.getDataTable();
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        toggleSelectAll(checked) {
            this.items.forEach(item => { item._selected = checked; });
            this.updateSelectAllState();
        },
        updateSelectAllState() { },
    },
};
</script>
